import React from 'react';
interface CTAButtonProps {
  text: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  text,
  href,
  className = ''
}: CTAButtonProps) {
  const baseStyles = 'inline-block w-full md:w-auto text-center bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xl md:text-2xl py-4 px-8 md:px-12 rounded-full shadow-[0_4px_14px_0_rgba(5,150,105,0.39)] transform transition-all duration-300 hover:scale-105 hover:shadow-[0_6px_20px_rgba(5,150,105,0.23)]';
  const handleClick = (e: React.MouseEvent) => {
    if (!href) {
      e.preventDefault();
      document.getElementById('purchase-section')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  if (href) {
    return <div className="flex flex-col items-center w-full" data-id="element-59">
        <a href={href} className={`${baseStyles} ${className}`} data-id="element-60">
          {text}
        </a>
        <span className="mt-3 text-sm font-bold text-stone-600 uppercase tracking-wide" data-id="element-61">
          HASTA 3 CUOTAS SIN INTERES
        </span>
      </div>;
  }
  return <div className="flex flex-col items-center w-full" data-id="element-62">
      <button onClick={handleClick} className={`${baseStyles} ${className}`} data-id="element-63">
        {text}
      </button>
      <span className="mt-3 text-sm font-bold text-stone-600 uppercase tracking-wide" data-id="element-64">
        HASTA 3 CUOTAS SIN INTERES
      </span>
    </div>;
}